
<template>
  <div class="admin">
    <Headers></Headers>
    <div class="admin-center">
      <div class="center-bg">
        <div class="bg-item">
          <h3>OSO智能运营管理系统</h3>
          <div class="item-show"></div>
          <p>琴行机构经营管理解决方案</p>
          <!-- <p>运营管理效率问题</p> -->
        </div>
        <img class="bg-image" :src="bgUrl" />
      </div>
      <div class="center-type">
        <h3>琴行掌中管理利器</h3>
        <p class="type-text">实时监管教学进度，高效管理教务工作</p>
        <div class="type-show"></div>
        <ul class="type-lists">
          <li v-for="(item, idx) in navData" :key="idx">
            <img :src="item.imgUrl" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.text1 }}</p>
            <p>{{ item.text2 }}</p>
            <p>{{ item.text3 }}</p>
            <p>{{ item.text4 }}</p>
            <p>{{ item.text5 }}</p>
            <p>{{ item.text6 }}</p>
          </li>
        </ul>
      </div>
      <div class="center-oso">
        <h3>配套OSO智能运营体系</h3>
        <p>助力琴行全面有效提升整体运营水平、提高市场竞争力</p>
        <div class="type-show"></div>
        <div class="oso-image">
          <img
            src="../assets/img/admin/admin(7).png"
          />
        </div>
      </div>
      <div class="center-nav">
        <h3>
          音乐窝正在为琴行<br />
          解决运营管理效率问题
        </h3>
        <div class="type-show"></div>
        <ul class="nav-list">
          <li
            :class="index == idx ? 'navShow' : ''"
            v-for="(item, idx) in navList"
            :key="idx"
            @click="onNavList(idx)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div
          class="nav-body"
          v-for="(item, idx) in listData"
          :key="idx"
          v-show="idx == itemidx ? show : hide"
        >
          <div class="body-title">{{ item.title }}</div>
          <P class="body-text">{{ item.text }}</P>
          <img :src="item.imgUrl" />
        </div>
      </div>
    </div>
    <div class="footerShow">
      <Footer></Footer>
    </div>
    <Fixed></Fixed>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Fixed from "@/components/leagueFixed.vue";

export default {
  name: "admin",
  data() {
    return {
      show: true,
      hide: false,
      navData: [
        {
          imgUrl: "https://aliyunosszs.musicwow.com/APPimg/admin/admin(3).png",
          title: "教务管理",
          text1: "机构课表",
          text2: "班级管理",
          text3: "排课销课",
          text4: "人员考勤",
        },
        {
          imgUrl: "https://aliyunosszs.musicwow.com/APPimg/admin/admin(5).png",
          title: "运营管理",
          text1: "预约课程",
          text2: "活动管理",
          text3: "学员权益",
          text4: "反馈汇总",
        },
        {
          imgUrl: "https://aliyunosszs.musicwow.com/APPimg/admin/admin(1).png",
          title: "财务管理",
          text1: "订单管理",
          text2: "财务明细",
          text3: "提成设置",
          text4: "课时结算",
        },
        {
          imgUrl: "https://aliyunosszs.musicwow.com/APPimg/admin/admin(2).png",
          title: "设置管理",
          text1: "消息管理",
          text2: "续费提醒",
          text3: "假期管理",
          text4: "审批管理",
          text5: "权限分配",
          text6: "教室管理",
        },
      ],
      navList: [
        {
          name: "教务管理混乱",
          id: 1001,
        },
        {
          name: "招生差留存难",
          id: 1002,
        },
        {
          name: "财务管理困难",
          id: 1003,
        },
        {
          name: "消息通知及时",
          id: 1004,
        },
      ],
      listData: [
        {
          title: "手机排销课、考勤简易方便",
          text: "自动生成课表，手机排课、销课、考勤， 随时查看排课及考勤状态，有效提高工作效率",
          imgUrl: "https://aliyunosszs.musicwow.com/APPimg/admin/iPhone@2x.png",
        },
        {
          title: "高效开展招生活动及学员权益",
          text: "多种模板活动及学员权益，满足不同机构活动需求， 快速开展活动推广，促进学员招生及留存",
          imgUrl:
            "https://aliyunosszs.musicwow.com/ad46f547591cd121fbbe0983a41c8e00.png",
        },
        {
          title: "高效准确管理账务",
          text: "订单、财务经营明细及结算统计，实时查询、 管理财务的好助手，有效避免人工记录造成的损失",
          imgUrl:
            "https://aliyunosszs.musicwow.com/4cac3c1200c4301a6d5e5ccb1ca52d9f.png",
        },
        {
          title: "重要消息及时掌握",
          text: "自由设置消息通知规则，实时管理及获取机构最新变动情况，轻松应对日常运营管理琐碎工作",
          imgUrl:
            "https://aliyunosszs.musicwow.com/ad46f547591cd121fbbe0983a41c8e00.png",
        },
      ],
      index: 0,
      itemidx: 0,
      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
    Fixed,
  },
  methods: {
    onNavList(idx) {
      // console.log(idx)
      this.index = idx;
      this.itemidx = idx;
    },
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_management":
            this.bgUrl = item.image;
            break;
        }
      });
    },
  },
  mounted() {},
  created() {
    this.onBulist();
  },
};
</script>
<style lang="sass" scoped>
.admin
  .admin-center
    padding-top: 60px
    text-align: left
    .center-bg
      color: #fff
      text-align: right
      position: relative
      .bg-item
        text-align: center
        background-image: url('https://aliyunosszs.musicwow.com/APPimg/admin/admin(4).png')
        background-size: 100% 100%
        width: 375px
        height: 302px
        position: relative
        h3
          font-size: 20px
          padding-top: 50px

        .item-show
          width: 25px
          margin: 10px auto
          background: #fff
          height: 2px
        p
          line-height: 17px
          letter-spacing: 10px
      .bg-image
        width: 340px !important
        height: 319px
        position: absolute
        z-index: 333
        top: 150px
        right: 0
    .center-type
      text-align: center
      padding-top: 220px
      h3
        font-size: 24px
        color: #5C5C5C
      .type-text
        font-size: 12px
        color: #9E9E9E
        padding: 10px 0
      .type-lists
        display: flex
        margin: 20px
        li
          margin: 20px auto
          max-width: 60px
          img
            width: 58px !important
            height: 60px
          h4
            font-size: 11px
            font-weight: 600
          p
            color: #9E9E9E
            font-size: 10px
            white-space: wrap
    .center-nav
      margin: 20px
      text-align: center
      h3
        font-size: 24px
        color: #5C5C5C
        line-height: 33px
      .nav-list
        display: flex
        .navShow
          background: #07D1AA
          color: #fff
        li
          border: 1px solid #EDEDED
          color: #C1C2C6
          flex: 5
          height: 29px
          line-height: 29px
          font-size: 11px
      .nav-body
        padding-top: 30px
        border: 1px solid #EDEDED
        margin: auto
        border-top: none
        .body-title
          font-size: 20px
          color: #333333
        .body-text
          max-width: 260px
          word-wrap: break-word
          padding: 10px 0
          color: #9E9E9E
          margin: auto
        img
          width: 100%
    .center-oso
      padding: 40px
      text-align: center
      h3
        font-size: 24px
        color: #5C5C5C
        line-height: 33px
      p
        font-size: 12px
        color: #9E9E9E
        padding: 10px 0
      img
        width: 100%
        margin-top: 10px
.type-show
  width: 44px
  height: 5px
  margin: 16px auto
  background: #07D1AA
.footerShow
  padding-bottom: 56px
</style>

